import { render } from "./BannerSwiper.vue?vue&type=template&id=320fd220&scoped=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"

import "./BannerSwiper.vue?vue&type=style&index=0&id=320fd220&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320fd220"]])

export default __exports__